module.exports = "/src/views/player/help/images/mech2.png";